<template>
  <div class="order-dailog col-block">
    <div class="title-container">
      <div class="title">訂單預覽</div>
    </div>
    <div class="data-container col-block" :style="{ flex: 1 }">
      <div class="data-block" v-for="(option, index) in displayOptions.filter(option => (option.display || (() => true))(param.order))" :key="index">
        <div class="title">{{ option.title }}</div>
        <div class="content">{{ option.value(param.order) }}</div>
      </div>
      <div :style="{ flex: 1 }"></div>
    </div>
    <div class="button-container row-block">
      <button class="main-button" @click="$emit('changeModal', {}, true)">
        <span>付款</span>
      </button>
      <div :style="{ width: '15px' }"></div>
      <button class="white-button" @click="$emit('changeModal', {})">
        <span>返回</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    methodOptions () {
      return [
        { title: '信用卡', value: 'credit' },
        { title: '實體ATM', value: 'atm' },
        { title: '網路ATM', value: 'eatm' }
      ]
    },
    displayOptions () {
      return [
        // {
        //   title: '所在地區',
        //   value: order => order ? order.country : ''
        // },
        {
          title: '受檢者姓名',
          value: order => order ? order.subject_name : ''
        },
        // {
        //   title: '身分證字號或護照號碼',
        //   value: order => order ? order.id_number : ''
        // },
        // {
        //   title: '出生日期',
        //   value: order => order ? order.birthday : ''
        // },
        {
          title: '性別',
          value: order => order ? order.gender : ''
        },
        {
          title: '電子郵件',
          value: order => order ? order.email : ''
        },
        {
          title: '聯絡人',
          value: order => order ? order.contact_name : ''
        },
        {
          title: '行動電話',
          value: order => order ? order.phone : ''
        },
        // {
        //   title: '居住縣市',
        //   value: order => order ? order.city : ''
        // },
        // {
        //   title: '醫生姓名(所在醫院)',
        //   value: order => order ? order.doctor_user.name + '(' + order.doctor_user.doctor_profile.hospital_name + ')' : ''
        // },
        {
          title: '產品選擇',
          value: order => order ? order.product.display : ''
        },
        {
          title: '付款方式',
          value: order => order ? (this.methodOptions.find(option => option.value === order.payment_method) || {}).title : ''
        },
        {
          title: '分期',
          value: order => order ? order.ecpay_credit_divide === 0 ? '不分期' : '分' + order.ecpay_credit_divide + '期' : '',
          display: order => ['credit'].includes(order.payment_method)
        },
        {
          title: '父親姓名',
          value: order => order ? order.father_subject_name : '',
          display: order => order && [3, 4].includes(order.product.subject_number)
        },
        {
          title: '父親身分證字號或護照號碼',
          value: order => order ? order.father_id_number : '',
          display: order => order && [3, 4].includes(order.product.subject_number)
        },
        {
          title: '父親出生日期',
          value: order => order ? order.father_birthday : '',
          display: order => order && [3, 4].includes(order.product.subject_number)
        },
        {
          title: '母親姓名',
          value: order => order ? order.mother_subject_name : '',
          display: order => order && [3, 4].includes(order.product.subject_number)
        },
        {
          title: '母親身分證字號或護照號碼',
          value: order => order ? order.mother_id_number : '',
          display: order => order && [3, 4].includes(order.product.subject_number)
        },
        {
          title: '母親出生日期',
          value: order => order ? order.mother_birthday : '',
          display: order => order && [3, 4].includes(order.product.subject_number)
        },
        {
          title: '受檢者2姓名',
          value: order => order ? order.subject_2_name : '',
          display: order => order && [4].includes(order.product.subject_number)
        },
        {
          title: '受檢者2身分證字號或護照號碼',
          value: order => order ? order.subject_2_id_number : '',
          display: order => order && [4].includes(order.product.subject_number)
        },
        {
          title: '受檢者2出生日期',
          value: order => order ? order.subject_2_birthday : '',
          display: order => order && [4].includes(order.product.subject_number)
        },
        {
          title: '受檢者2性別',
          value: order => order ? order.subject_2_gender : '',
          display: order => order && [4].includes(order.product.subject_number)
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/order.vue